import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../../shared/global';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class ExpressPayService {
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest = GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private check_mobile_url = this.baseApiUrl + 'api/rest/v1/auth/mobile/';
  private check_mobile_url = this.baseApiUrlTest + 'api/auth/check/mobile';
  // private check_email_url = this.baseApiUrl + 'api/rest/v1/auth/email/';
  private check_email_url = this.baseApiUrlTest + 'api/auth/check/email/';
  constructor(private http: Http, private localStorageService: LocalStorageService) { }

  mobileNoExist(mobile_phone_number: Object) {
    return this.http
      .post(this.check_mobile_url, mobile_phone_number)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  emailExist(email: Object){
    return this.http
      .post(this.check_email_url, email)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/express-pay/express-pay.service.ts